<template>
    <div id="duixiang">
        <h5>{{ app ? app.app_name : '' }}</h5>
        <el-container>
            <el-aside width="180px">
                <SubMenu activeIndex="6" />
            </el-aside>
            <el-main>
                <el-row type="flex" justify="center">
                    <el-switch style="display: block" v-model="switch_value" active-color="teal" inactive-color="#ff4949" active-text="发布" inactive-text="关闭" @change="handleChange">
                    </el-switch>
                </el-row>
                <el-row v-show="switch_value">
                    <canvas id="qr"></canvas>
                    <!-- {{this.jiancha_action_url}} -->
                </el-row>

            </el-main>
        </el-container>
    </div>
</template>
<script>
import axios from 'axios'
import config from '../config.js'
import SubMenu from './SubMenu.vue'
import QRious from 'qrious'
export default {
    components: {
        SubMenu,
    },
    data() {
        return {

            app_id: '',
            app: null,
            switch_value: '',
            jiancha_action_url: '',

        }

    },
    created() {
        this.app_id = this.$route.params.app_id
        this.app = JSON.parse(localStorage.getItem(this.app_id))
        if (!this.app) { this.getApp() }
        if (this.app) {

            if (this.app.is_published) {
                this.switch_value = true

            } else {
                this.switch_value = false
            }
        }

        //this.jiancha_action_url = config.base_url + '/admin#/jianchaaction/' + this.app_id
        this.jiancha_action_url = 'http://www.weicell.com' + '/admin#/jianchaaction/' + this.app_id
    },
    mounted() {

        var canvas = document.querySelector('canvas');
        var qr = new QRious({
            element: canvas,
            value: this.jiancha_action_url
        });
    },
    methods: {
        getApp() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.app = res
                if (this.app.is_published == 2) {
                    this.switch_value = true
                } else {
                    this.switch_value = false
                }
                this.jiancha_action_url = config.base_url + '/admin#/jianchaaction/' + this.app_id
            }).catch((err) => {
                //console.log(err);
            })
        },


        handleChange() {
            if (this.switch_value) {
                //发布
                let _this = this
                let app = this.app
                app.is_published = 2
                axios({
                        method: 'put',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        url: config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id,
                        data: app
                    })
                    .then(function(response) {

                        _this.$message({
                            message: '发布成功',
                            type: 'success'
                        });
                        (function() {
                            var qr = new QRious({
                                element: document.getElementById('qr'),
                                value: _this.jiancha_action_url
                            });
                        })();

                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })
            } else {
                //发布
                let _this = this
                let app = this.app
                app.is_published = 1
                axios({
                        method: 'put',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        url: config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id,
                        data: app
                    })
                    .then(function(response) {

                        _this.$message({
                            message: '应用已关闭',
                            type: 'success'
                        });

                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })
            }
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>